import jQuery from 'jquery';

// case studies carousels
jQuery('.cs-photos-carousel').slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  draggable: false,
  fade: true,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  customPaging: function(slider, i) {
    return '<button>' + jQuery(slider.$slides[i]).find('img').attr('title') +'</button>';
  },
  appendDots: jQuery('.cs-carousels-dots'),
  asNavFor: '.cs-opinions-carousel, .cs-garages-names-carousel',
});

jQuery('.cs-opinions-carousel').slick({
  arrows: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  draggable: false,
  fade: true,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 1,
});

jQuery('.cs-garages-names-carousel').slick({
  arrows: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  draggable: false,
  fade: true,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 1,
});

// our philosophy carousel
jQuery('.our-philosophy-carousel').slick({
  arrows: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: true,
  draggable: true,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
